import { useDark } from '@vueuse/core'
import { useThemeStore } from '@/stores/theme'

export type ThemeMode = keyof typeof THEME_MAP
// 主题类型映射表
export const THEME_MAP = {
  auto: 0,
  dark: 1,
  light: 2,
} as const

// TODO: 临时方案 - 深色模式颜色未完善，auto 模式暂时强制使用 light
// 等深色模式颜色修复后，将此值改为 false 即可恢复跟随系统功能
const FORCE_AUTO_TO_LIGHT = false

export function useThemeChange() {
  const themeStore = useThemeStore()
  const isDark = useDark({
    valueDark: 'dark hljs-dark',
    valueLight: 'light hljs-light',
  })
  const { store: colorModeStore, system: uiColorMode } = useColorMode()

  const setTheme = (theme: ThemeMode) => {
    // 获取当前实际的主题值（light/dark）
    const currentActualTheme
      = colorModeStore.value === 'auto'
        ? uiColorMode.value
        : colorModeStore.value

    // 计算新主题的实际值
    const newActualTheme = theme === 'auto'
      ? (FORCE_AUTO_TO_LIGHT ? 'light' : uiColorMode.value)
      : theme

    // 如果实际主题发生变化，需要播放动画
    if (newActualTheme !== currentActualTheme) {
      themeStore.setShowThemeTransition(true)
      setTimeout(() => {
        colorModeStore.value = FORCE_AUTO_TO_LIGHT && theme === 'auto' ? 'light' : theme
      }, 100)
    }
    else {
      // 即使实际主题没变，也要更新存储值，让菜单正确高亮
      colorModeStore.value = FORCE_AUTO_TO_LIGHT && theme === 'auto' ? 'light' : theme
    }
  }

  watch(colorModeStore, async (newVal, oldVal) => {
    if (newVal !== oldVal) {
      setTimeout(() => {
        themeStore.setShowThemeTransition(false)
      }, 2000)
    }
  })

  return {
    isDark,
    setTheme,
  }
}
